<!-- Sign-up Form Page 3 -->
<section>
    <div class="container content-box">

        <!-- Form -->
        <form name="form" (submit)="onSubmit(f.form)" #f="ngForm" novalidate>

            <!-- Header -->
            <h1 class="mb-3 text-center">Sign Up</h1>
            <p class="text-center no-margin">Fill in this form and click "Finish" to complete your registration with us!</p>
            <p class="text-center"><small>$30 + processing fees to those with addresses outside of Nebraska.</small></p>
            <hr>

            <!-- Input Fields -->
            <div class="col-md-12">

                <!-- Input Row -->
                <div class="row mt-2">

                    <!-- Annual Income -->
                    <div class="col-md-6">
                        <label class="required-field">Household Annual Income</label>
                        <select name="annualIncome" id="annualIncome" class="form-control mb-2" [(ngModel)]="user.annualIncome" name="annualIncome" #annualIncome="ngModel" [ngClass]="{ 'is-invalid': submitted && annualIncome.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option value="$0 - $24,999">$0 - $24,999</option>
                            <option value="$25,000 - $49,999">$25,000 - $49,999</option>
                            <option value="$50,000 - $74,999">$50,000 - $74,999</option>
                            <option value="$75,000 - $99,999">$75,000 - $99,999</option>
                            <option value="$100,000 - $149,999">$100,000 - $149,999</option>
                            <option value="$150,000 - $249,999">$150,000 - $249,999</option>
                            <option value="$250,000 or more">$250,000 or more</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="submitted && annualIncome.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="annualIncome.errors!.required">Income is required</div>
                        </div>
                    </div>

                    <!-- Primary Source of Income -->
                    <div class="col-md-6">
                        <label class="required-field">Primary Source of Income</label>
                        <select name="incomeSource" id="incomeSource" class="form-control mb-2" [(ngModel)]="user.sourceOfIncome" name="sourceOfIncome" #incomeSource="ngModel" [ngClass]="{ 'is-invalid': submitted && incomeSource.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option value="Employment">Employment</option>
                            <option value="Unemployment">Unemployment</option>
                            <option value="SSI">SSI</option>
                            <option value="SSDI">SSDI</option>
                            <option value="TANF-ADC">TANF-ADC</option>
                            <option value="Student Loans/Grants">Student Loans/Grants</option>
                            <option value="Other">Other</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="submitted && incomeSource.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="incomeSource.errors!.required">Primary income source is required</div>
                        </div>
                    </div>
                </div>

                <!-- Street Address -->
                <label class="required-field">Street Address 1</label>
                <input type="text" id="address1" class="form-control mb-2" placeholder="#### StreetName St." [(ngModel)]="user.streetAddress" name="streetAddress" #streetAddress="ngModel" [ngClass]="{ 'is-invalid': submitted && streetAddress.invalid }" required>

                <!-- Invalid -->
                <div *ngIf="submitted && streetAddress.invalid" class="invalid-feedback">
                    <div class="mb-2" *ngIf="streetAddress.errors!.required">Street address is required</div>
                </div>

                <!-- Input Row -->
                <div class="row mt-2">

                    <!-- Street Address 2 -->
                    <div class="col-md-6">
                        <label>Street Address 2</label>
                        <input type="text" id="secondary" class="form-control mb-2" placeholder="(Optional)" [(ngModel)]="user.secondary" name="secondary" #secondary="ngModel">
                    </div>

                    <!-- Phone Number -->
                    <div class="col-md-6">
                        <label class="required-field">Phone Number</label>
                        <input type="phone" id="phone" class="form-control mb-2" placeholder="Phone Number" name="phone" required [(ngModel)]="user.phone" [pattern]="phonePattern" #uname="ngModel" #phone="ngModel" [ngClass]="{ 'is-invalid': submitted && phone.invalid }">

                        <!-- Invalid Phone Number-->
                        <div *ngIf="submitted && phone.invalid || submitted && uname.errors?.pattern" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="phone.errors!.required">Phone number is required</div>
                            <div class="mb-1 text-center" *ngIf="uname.errors?.pattern">Must be a valid phone number</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-2">

                    <!-- City -->
                    <div class="col-md-5">
                        <label class="required-field">City</label>
                        <input type="text" id="city" class="form-control mb-2" [(ngModel)]="user.city" name="city" #city="ngModel" [ngClass]="{ 'is-invalid': submitted && city.invalid }" required>

                        <!-- Invalid -->
                        <div *ngIf="submitted && city.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="city.errors!.required">City is required</div>
                        </div>
                    </div>

                    <!-- State -->
                    <div class="col-md-3">
                        <label class="required-field">State</label>
                        <select name="state" id="state" class="form-control mb-2" placeholder="--" [(ngModel)]="user.state" name="state" #state="ngModel" [ngClass]="{ 'is-invalid': submitted && state.invalid }" required>
                          <option value="" selected="selected" disabled="disabled">--</option>
                          <option value="AL">Alabama</option>
	                        <option value="AK">Alaska</option>
	                        <option value="AZ">Arizona</option>
	                        <option value="AR">Arkansas</option>
	                        <option value="CA">California</option>
	                        <option value="CO">Colorado</option>
	                        <option value="CT">Connecticut</option>
	                        <option value="DE">Delaware</option>
	                        <option value="DC">District Of Columbia</option>
	                        <option value="FL">Florida</option>
	                        <option value="GA">Georgia</option>
	                        <option value="HI">Hawaii</option>
	                        <option value="ID">Idaho</option>
	                        <option value="IL">Illinois</option>
	                        <option value="IN">Indiana</option>
	                        <option value="IA">Iowa</option>
	                        <option value="KS">Kansas</option>
	                        <option value="KY">Kentucky</option>
	                        <option value="LA">Louisiana</option>
	                        <option value="ME">Maine</option>
	                        <option value="MD">Maryland</option>
	                        <option value="MA">Massachusetts</option>
	                        <option value="MI">Michigan</option>
	                        <option value="MN">Minnesota</option>
	                        <option value="MS">Mississippi</option>
	                        <option value="MO">Missouri</option>
	                        <option value="MT">Montana</option>
	                        <option value="NE">Nebraska</option>
	                        <option value="NV">Nevada</option>
	                        <option value="NH">New Hampshire</option>
	                        <option value="NJ">New Jersey</option>
	                        <option value="NM">New Mexico</option>
	                        <option value="NY">New York</option>
	                        <option value="NC">North Carolina</option>
	                        <option value="ND">North Dakota</option>
	                        <option value="OH">Ohio</option>
	                        <option value="OK">Oklahoma</option>
                        	<option value="OR">Oregon</option>
                        	<option value="PA">Pennsylvania</option>
                          <option value="RI">Rhode Island</option>
                          <option value="SC">South Carolina</option>
                          <option value="SD">South Dakota</option>
	                        <option value="TN">Tennessee</option>
                          <option value="TX">Texas</option>
	                        <option value="UT">Utah</option>
	                        <option value="VT">Vermont</option>
	                        <option value="VA">Virginia</option>
	                        <option value="WA">Washington</option>
	                        <option value="WV">West Virginia</option>
	                        <option value="WI">Wisconsin</option>
	                        <option value="WY">Wyoming</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="submitted && state.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="state.errors!.required">State is required</div>
                        </div>
                    </div>

                    <!-- Zip Code -->
                    <div class="col-md-4">
                        <label class="required-field">Zip Code</label>
                        <input type="text" id="zipCode" class="form-control mb-2" placeholder="#####" [(ngModel)]="user.zipCode" name="zipCode" #zipCode="ngModel" [ngClass]="{ 'is-invalid': submitted && zipCode.invalid }" required>

                        <!-- Invalid -->
                        <div *ngIf="submitted && zipCode.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="zipCode.errors!.required">Zipcode is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-2">

                    <!-- County -->
                    <div class="col-md-3">
                        <label class="required-field">County</label>
                        <input type="text" id="county" class="form-control mb-2" [(ngModel)]="user.county" name="county" #county="ngModel" [ngClass]="{ 'is-invalid': submitted && county.invalid }" required>

                        <!-- Invalid -->
                        <div *ngIf="submitted && county.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="county.errors!.required">County is required</div>
                        </div>
                    </div>

                    <!-- Primary Residence -->
                    <div class="col-md-4">
                        <label class="required-field">Is this your Primary Residence?</label>
                        <select name="isPrimaryResidence" id="isPrimaryResidence" class="form-control mb-2" [(ngModel)]="user.primaryResidence" name="primaryResidence" #primaryResidence="ngModel" [ngClass]="{ 'is-invalid': submitted && primaryResidence.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="submitted && primaryResidence.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="primaryResidence.errors!.required">Primary residence is required</div>
                        </div>
                    </div>

                    <!-- Living Situation -->
                    <div class="col-md-5">
                        <label class="required-field">Living Situation</label>
                        <select name="livingSituation" id="livingSituation" class="form-control mb-2" [(ngModel)]="user.livingSituation" name="livingSituation" #livingSituation="ngModel" [ngClass]="{ 'is-invalid': submitted && livingSituation.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option value="Living with Family/Friends">Living with Family/Friends</option>
                            <option value="Rental House">Rental House</option>
                            <option value="Apartment">Apartment</option>
                            <option value="Emergency Shelter">Emergency Shelter</option>
                            <option value="Group Home">Group Home</option>
                            <option value="Government Subsidized Housing">Government Subsidized Housing</option>
                            <option value="Substance Abuse Treatment Center">Substance Abuse Treatment Center</option>
                            <option value="Own Home">Own Home</option>
                            <option value="Place Not Meant for Habitation">Place Not Meant for Habitation</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="submitted && livingSituation.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="livingSituation.errors!.required">Living situation is required</div>
                        </div>
                    </div>
                </div>

                <!-- EULA -->
                <div class="row mt-2">
                    <div class="col-md-6">
                        <input type="checkbox" name="eula" id="eula" class="mb-2" name="eula" [(ngModel)]="eulaModel.eula" name="eula" #eula="ngModel" [ngClass]="{ 'is-invalid': submitted && eula.invalid }" required />
                        <label for="eula" class="ml-2">I agree to the tool's <a href="../../../assets/End User Agreement.pdf" target="_blank">End-User License Agreement.</a></label>

                        <!-- Invalid -->
                        <div *ngIf="submitted && eula.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="eula.errors!.required">Required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-3" *ngIf="recaptchaEnabled">

                    <!-- Captcha -->
                    <div class="col-md-12 mb-4 input-field text-center">
                        <re-captcha #captcha="ngModel" [(ngModel)]="user.captcha" id="captcha" name="captcha" class="captcha" [ngClass]="{ 'is-invalid': submitted && captcha.invalid }" required></re-captcha>

                        <!-- Invalid -->
                        <div *ngIf="submitted && captcha.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="captcha.errors!.required">Captcha is required</div>
                        </div>
                    </div>
              </div>
            </div>

            <!-- Next page button -->
            <div class="text-center">
                <button type="submit" class="btn mb-4" [class.disabled]="submitting || geolocating" *ngIf="user.state === 'NE'">Finish</button>
                <button type="submit" class="btn mb-4" [class.disabled]="submitting || geolocating" *ngIf="user.state !== 'NE'">Next</button>
            </div>

            <!-- Login Link-->
            <p class="mb-4 center text-center">Already have an account?
                <a [routerLink]="'/login'">Login</a>
            </p>
        </form>
    </div>
</section>
